import {
  ComponentDefinitionDetailsTranslation,
  componentDefinitionDetailsTranslation,
} from '@/assets/locales/views/componentDefinitions/details/componentDefinitionDetails.translation.pl.ts';
import {
  componentDefinitionsListTranslation,
  ComponentDefinitionsListTranslation,
} from '@/assets/locales/views/componentDefinitions/list/componentDefinitionsList.translation.pl.ts';

export type ComponentDefinitionsTranslation = {
  details: ComponentDefinitionDetailsTranslation;
  list: ComponentDefinitionsListTranslation;
};

export const componentDefinitionsTranslation: ComponentDefinitionsTranslation = {
  details: componentDefinitionDetailsTranslation,
  list: componentDefinitionsListTranslation,
};
